import React, { useEffect, useState } from "react";
import { Common } from "../../components";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { actionLendelaHealthCheck, actionLendelaVerify } from "../../store/lendela/action";
import { alphabetOnly, numberWithNoCommas, pad, saveSessionInfo } from "../../utils/common";
import Error from "../../components/PopUpBox/Error";
import { actionSendOTP } from "../../store/application/actions";

function LendelaVerify() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [isVisibleError, setIsVisibleError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!token) {
            navigate('/');
        } else {
            localStorage.setItem('access_token', token);
        }
    }, [token, navigate]);

    const showMessage = (message) => {
        setErrorMessage(message);
        setIsVisibleError(true);
    }

    useEffect(() => {
        setLoading(true);
        async function health_check() {
            const response = await dispatch(actionLendelaHealthCheck());
            if (response?.sts_code !== 0) {
                console.log('redirect is home page');
                window.location.href = `${process.env.REACT_APP_HOME_URL}`;
            }
            setLoading(false);
        }
        health_check()
        saveSessionInfo();
    }, []);

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm();

    const onSubmit = async (data) => {
        console.log(data);
        const date_of_birth = `${data?.year}-${pad(data?.month)}-${pad(data?.day)}`;
        console.log('date_of_birth', date_of_birth);
        const payload = {
            date_of_birth
        };
        setLoading(true);
        const response = await dispatch(actionLendelaVerify(payload));
        console.log('res', response);
        if (response?.sts_code === 0) {
            const content = response?.content;
            if (content?.phone_number) {
                sendOtp(content.phone_number, content.lendela_app_id);
            }
        } else {
            showMessage('認證失敗，請確認資料正確');
        }
        setLoading(false);
    }

    const sendOtp = async (phone, app_id) => {
        setLoading(true)
        const response = await dispatch(
            actionSendOTP({
                phone: phone,
            })
        );
        if (response?.sts_code === 0) {
            navigate('/application-otp', { state: { phone, lendela_app_id: app_id } });
        }
        setLoading(false);
    }

    return (
        <>
            <Common.Loading isVisible={isSubmitting || isLoading} />
            {isVisibleError && <Error content={errorMessage} onClick={() => setIsVisibleError(false)}>
                <div className="text-center my-3">
                    <button onClick={() => setIsVisibleError(false)} type="button" className="rounded-full text-white text-sm bg-lightningYellow px-10 py-2">
                        確認
                    </button>
                </div>
            </Error>}
            <div className="bg-white p-5">
                <p className="flex-1 text-2xl text-primary2 text-right font-semibold border-b border-gray2 mb-4 pb-4">登入以繼續貸款申請</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-5 py-7 border border-gray2 rounded-lg">
                        <div className="mt-8">
                            <p className="text-xl font-bold text-gray mb-2">出生日期</p>
                            <div className="flex">
                                <input maxLength={4} {...register('year', {
                                    required: true,
                                    onChange: (e) => {
                                        const value = numberWithNoCommas(e?.target?.value + '')
                                        setValue('year', value.toUpperCase())
                                    }
                                })} className="outline-none border-b w-1/3 border-primary pb-1 text-primary" placeholder="YYYY" />
                                <input maxLength={2} {...register('month', {
                                    required: true,
                                    onChange: (e) => {
                                        const value = numberWithNoCommas(e?.target?.value + '')
                                        setValue('month', value.toUpperCase())
                                    }
                                })} className="outline-none border-b w-1/3 border-primary ml-5 pb-1 text-primary" placeholder="MM" />
                                <input maxLength={2} {...register('day', {
                                    required: true,
                                    onChange: (e) => {
                                        const value = numberWithNoCommas(e?.target?.value + '')
                                        setValue('day', value.toUpperCase())
                                    }
                                })} className="outline-none border-b w-1/3 border-primary ml-5 pb-1 text-primary" placeholder="DD" />
                            </div>
                            {(errors?.year && errors?.year?.type === 'required' || (errors?.month && errors?.month?.type === 'required')
                                || (errors?.day && errors?.day?.type === 'required')) && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                        <div className="flex justify-center mb-4 mt-10">
                            <button type="submit" disabled={isSubmitting} className={`rounded-full text-white text-xl px-14 py-2 ${isSubmitting ? 'bg-mercury' : 'bg-primary'}`}>
                                獲取驗證碼
                            </button>
                        </div>
                        <p className="text-gray2 text-sm text-center">（驗證碼將會發送到閣下登記之手提電話號碼）</p>
                    </div>
                </form>
            </div>
        </>
    )
}

export default LendelaVerify;